module.exports = __webpack_public_path__ + "static/img/住院告知书@3x.7f58661.png";


//////////////////
// WEBPACK FOOTER
// ./src/page/dhry/assets/navs/住院告知书@3x.png
// module id = 305
// module chunks = 379 380